import React from 'react';
import { FiLogOut, FiShoppingCart } from 'react-icons/fi';
import { MdOutlineSearch } from 'react-icons/md';
import { IoIosClose } from 'react-icons/io';
import { Link } from 'react-router-dom';

const ShopHeader = ({
    color,
    backgroundcolor,
    shouldShowGroups,
    cartCount,
    searchInput,
    setSearchInput,
    searchText,
    isloadingSearch,
    onExit,
    onSearch,
    onSearchClose,
    children
}) => {
    return (
        <div
            className={`header ${!shouldShowGroups ? 'no-groups' : ''}`}
            style={{ color, background: backgroundcolor }}
        >
            <div
                className="btnShop exit"
                onClick={onExit}
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#f44336', cursor: 'pointer' }}
            >
                <FiLogOut size="25px" />
                <span style={{ color: 'red' }}>خروج</span>
            </div>

            <Link to={cartCount > 0 ? '/ShopBasket' : '#'}>
                <div
                    className="btnShop basket"
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#4caf50' }}
                >
                    <FiShoppingCart size="25px" />
                    <span style={{ color: 'green', fontSize: '12px' }}>خرید</span>
                    <span className="counter-basket">{cartCount}</span>
                </div>
            </Link>

            <div className="search">
                <div className="container-shop">
                    <input
                        type="text"
                        id="search-text"
                        value={searchInput}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') onSearch();
                            else if (e.key === 'Escape') onSearchClose();
                        }}
                        placeholder="کالای مورد نظر را جستجو کنید"
                        onChange={(e) => setSearchInput(e.target.value)}
                    />

                    <div
                        className="btn-search"
                        onClick={(e) => {
                            e.stopPropagation();
                            onSearch();
                        }}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                    >
                        {isloadingSearch && searchText ? (
                            <div
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    border: '3px solid rgba(0,0,0,0.1)',
                                    borderTop: '3px solid #666',
                                    borderRadius: '50%',
                                    animation: 'spinCustom 1s linear infinite'
                                }}
                            />
                        ) : (
                            <MdOutlineSearch size="25px" />
                        )}
                    </div>

                    {(searchInput ?? '').length > 0 && (
                        <div className="search-close" style={{ cursor: 'pointer' }}>
                            <IoIosClose size="25px" color="black" onClick={onSearchClose} />
                        </div>
                    )}
                </div>
            </div>

            {children}
        </div>
    );
};

export default React.memo(ShopHeader);
